<template>
  <div class="d-timetal__container">
    <h3 class="text-explainer text-explainer__error" v-if="error">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-important"><path class="primary" d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"/><path class="secondary" d="M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"/></svg>
      Der er stadig oplysninger der skal udfyldes før der kan indberettes
    </h3>
    <div class="d-timetal__container__header">
      <h2 class="uppercase">Resume</h2>
    </div>
    <div class="d-attention" v-if="klasserUdenFag.length > 0">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-important"><path class="primary" d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"/><path class="secondary" d="M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"/></svg>
      <h3>Følgende klasser har ingen fag, og skal derfor ikke indberettes.</h3>
      <p>Slet dem i denne liste, hvis de ikke skal indberettes</p>
      <table class="d-table d-table__borders">
        <tbody>
        <tr v-for="(klasse, key) in klasserUdenFag" :key="klasse.klasse_id">
          <td>
            <div class="grade-name">
              <div class="hint--top-right d-hidden__dropdown"
                   :aria-label="'Slet ' + klasse.klassebetegnelse + ' fra indberetningen'">
                <button class="icon__bg-circle icon__bg-circle--danger"
                        @click="confirmDeleteGrade(klasse)">
                  <span class="icon-bin"></span>
                </button>
              </div>
            {{ klasse.klassebetegnelse }}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <IndberetetPersonale :stilData="stilData">
    </IndberetetPersonale>
    <IndberetFag :stilData="stilData">
    </IndberetFag>
    <div class="submit-bttn__container">
      <div class="hint--left"
           v-if="error"
           aria-label="Der er stadig oplysninger der skal udfyldes før der kan indberettes">
        <button class="bttn bttn--primary bttn--primary--disabled"
                style="width: 165px">
          Afslut og indberet
        </button>
      </div>
      <button class="bttn bttn--primary"
              v-else
              style="width: 165px"
              :class="{'bttn--loading': isSendingToStil}"
              @click="submit">Afslut og indberet
      </button>
    </div>
    <DModal :is-bg-overlay="true" v-if="messageFromStil.length > 0" :show-close="false">
      <div slot="insertComponent" class="d-modal">
        <div class="doc-modal__header">
          <h2>Svar fra STIL</h2>
          <div class="doc-modal__close icon__bg-circle" @click="messageFromStil = ''">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="doc-modal__body">
          <p class="message-from-stil">"{{ messageFromStil }}"</p>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import DModal from '../../common/DModal'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'
import IndberetetPersonale from './Resume/IndberetPersonale'
import IndberetFag from './Resume/IndberetFag'

export default {
  components: {IndberetFag, IndberetetPersonale, DModal},
  props: {
    stilData: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      isSendingToStil: false,
      messageFromStil: ''
    }
  },
  computed: {
    schoolId () {
      return this.$route.params.school_id
    },
    error () {
      return this.stilData['error'] ? this.stilData['error'] : false
    },
    klasser () {
      return this.stilData['klasser'] ? this.stilData['klasser'] : []
    },
    klasserUdenFag () {
      return this.klasser.filter(klasse => klasse.fag.length === 0)
    }
  },
  methods: {
    confirmDeleteGrade (grade) {
      const klasseId = grade.klasse_id
      const report = JSON.parse(JSON.stringify(this.stilData))
      const klasseIdx = report.klasser.findIndex(klasse => klasse.klasse_id === klasseId)
      if (klasseIdx < 0) {
        return
      }
      report.klasser.splice(klasseIdx, 1)
      this.$emit('updateStil', report)
    },
    submit () {
      this.isSendingToStil = true
      this.messageFromStil = ''
      docendo.submitStilCompetencyReport(this.schoolId, success => {
        this.messageFromStil = success
        this.isSendingToStil = false
      }, failure => {
        eventbus.toast = {text: 'Noget gik galt', success: false}
        this.isSendingToStil = false
      })
    }
  }
}
</script>

<style scoped>
.doc-modal__header {
  color: #222222;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.submit-bttn__container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
}

.message-from-stil {
  font-style: italic;
  border: 1px solid #eee;
  padding: 1rem;
  background: #ffffff;
  border-radius: 4px;
}

.text-explainer__error {
  border: 1px solid #ccc;
  padding: 4rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-explainer__error .tw-icon {
  width: 3rem;
  margin-right: 1rem;
}

.d-timetal__container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// KompetenceIndberetningIndberet.vue?1fe85746